<div fxLayout="column" fxFlexFill class="d3-chart" #chart>
</div>
